import React from 'react';
import { Col, Row } from 'antd';

export default ({ label, value, labelSpan, valueSpan }) => (
	<Row style={{ marginBottom: 8 }}>
		<Col span={labelSpan || 2}>{label}</Col>
		<Col span={valueSpan || 22}>: {value || '---'}</Col>
	</Row>
);
